<template>
    <div class="drop-down">
        <div @click="toggleDropdown" v-if="showDropdownContent" class="overlay"/>
        <button @click="toggleDropdown" class="drop-down__button" :class="{'drop-down__button-opened': showDropdownContent}">
            <div class="d-flex align-items-center">
                <Icon class="button-icon" :icon="info.icon"/>
                <p class="drop-down__title m-0">
                    {{info.title}}
                </p>
            </div>
            <Icon :class="{'rotated': showDropdownContent}" class="arrow" icon="arrow-down"/>
        </button>
        <ul v-if="showDropdownContent" class="drop-down__content">
            <li v-for="item in info.list" :key="item.text" class="drop-down__item">
                <label class="checkbox-container">
                    <span class="checkmark"></span>
                    <input 
                        type="checkbox" 
                        :value="item" 
                        v-model="checkedValues" 
                        @change="onValueCheck"
                    > 
                        {{item.text}}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import { truncate } from '../../../../core/filters'
import Icon from '../../../Theme/Icon.vue'


export default {
    name: 'Dropdown',
    components: {
        Icon
    },
    props: {
        info: Object,
        reseted: Boolean,
        removedItem: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showDropdownContent: false,
            checkedValues: []
        }
    },
    mounted(){
        if(!this.$route.query.filters) {
            return
        }

        const filters = JSON.parse(this.$route.query.filters)

        if(filters[this.info.key]) {
            this.info.list.forEach(item => {

                if(filters[this.info.key].indexOf(item.value) !== -1 && this.info.key === 'category') {
                    this.checkedValues.push(item)
                } 

                if(JSON.stringify(filters[this.info.key]).includes(JSON.stringify(item.value)) && this.info.key === 'monthlySales') {
                    this.checkedValues.push(item)
                }
            })
        }
    },
    watch: {
        'removedItem': 'onValueCheck',
        'reseted': 'clearCheckedValues'
    },
    methods: {
        toggleDropdown() {
            this.showDropdownContent = !this.showDropdownContent
            this.$store.commit('SET', ['openedDropdown', this.showDropdownContent])
        },
        clearCheckedValues() {
            if(!this.reseted) {
                return
            }
            this.checkedValues = []
        },
        onValueCheck() {
            let removedItemInCheckedValues;
            if(this.removedItem) {
                if(this.removedItem.key === 'monthlySales') {
                    removedItemInCheckedValues = this.checkedValues.findIndex(el => el.value[0] === this.removedItem.value[0])
                } else if(this.removedItem.key === 'category') {
                    removedItemInCheckedValues = this.checkedValues.findIndex(el => el.value === this.removedItem.value)
                }
                if(removedItemInCheckedValues !== -1) {
                    this.checkedValues.splice(removedItemInCheckedValues, 1)
                    this.$emit('clearRemovedItem', undefined)
                }
            }
            this.$emit('onCheck', {
                title: this.info.title,
                checkedValues: this.checkedValues,
                key: this.info.key
            })
        }
    },
    filters: {
        truncate
    }
}
</script>

<style lang="scss" scoped>
$max_width: 215px;
$white: #ffffff;
$border_radius: 8px;
$border: 1px solid #CBD5E0;
$button_color: #718096;
$button_fontsize: 16px;
$button_lineheight: 24px;
$button_padding: 8px 16px;
$fontsize: 14px;
$lineheight: 20px;
$color: #333333;
$item_padding: 12px;
$box_shadow: 0px -4px 20px -6px rgba(113, 128, 150, 0.32), 0px 8px 20px -6px rgba(113, 128, 150, 0.32), 0px 0px 1px rgba(113, 128, 150, 0.32);
$hover_background:#F4F7FA;
$item_shadow: inset 0px -1px 0px #EDF2F7;
$transition: all 0.2s ease; 
.drop-down {
    position: relative;
    margin-right: 16px;
    min-width: 185px;
    max-width: $max_width;
    width: 100%;
    &:hover {
        box-shadow: 0px 4px 12px -6px rgba(113, 128, 150, 0.12)
    }
    .overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1000;
    }
    &__button {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        border-radius: $border_radius;
        padding: $button_padding;
        font-size: $button_fontsize;
        line-height: $button_lineheight;
        color: $button_color;
        border: $border;
        p {
            margin-left: 12px !important;
        }
        img{
            transition: all 0.2s ease;
            &.arrow {
                margin-right: 4px;
                &.rotated {
                    transform: rotate(-180deg);
                }
            }
        }
        &-opened {
            background: $white;
        }
    }
    &__title {
        line-height: 25px;
    }
    &__content {
        position: absolute;
        width: 100%;
        background: $white;
        top: 100%;
        left: 0;
        transform: translate(0, 12px);
        box-shadow: $box_shadow;
        border-radius: $border_radius;
        padding: 0;
        z-index: 1000;
        overflow: hidden;
    }
    &__item {
        color: $color;
        font-size: $fontsize;
        line-height: $lineheight;
        transition: $transition;
        cursor: pointer;
        box-shadow: $item_shadow;
        label.checkbox-container {
            cursor: pointer;
            margin: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            padding: $item_padding;

            input[type="checkbox"] {
                margin-right: 8px;
            }
        }
        &:hover {
            background: $hover_background;
        }
    }
}
</style>